export const calcNewIndex = (len: number, idx: number, interval: number = 1) => ({
  // nextIndex: (idx + 1) % len
  next: (Math.min(idx, len - 1) + Math.abs(interval)) % len,
  // prev: (idx + len - 1) % len,
  prev: (Math.min(idx, len - 1) - Math.abs(interval) + len) % len,
});
